// order_tracking.js — Schéma Zod partagé rx.v1 `order_tracking` (CONTRAT FIGÉ A3)
// Référence : /app/architecture/rx-engine/CONTRACT_order_tracking_v1.md
// Toute évolution = order_tracking.v2 — jamais de mutation silencieuse.
const { z } = require('zod');

const TRACKING_STATES = [
  'confirmed', 'merchant_accepted', 'dispatch_pending', 'courier_assigned',
  'dispatched', 'assigned', 'pickup_arrived', 'picked_up',
  'en_route', 'proof_pending', 'completed', 'delivered',
  'dispatch_expired', 'disputed', 'cancelled',
];

const TrackingStatusSection = z.object({
  type: z.literal('tracking_status'),
  order_id: z.string().uuid(),
  state: z.enum(TRACKING_STATES),
  state_label: z.string().min(1),
  resource: z.object({
    first_name: z.string().min(1),
    rating: z.number().min(0).max(5).nullable(),
  }).nullable(),
  eta_min: z.number().int().positive().nullable(),
  pin: z.string().regex(/^\d{4}$/).nullable(), // client propriétaire uniquement
  amount_fcfa: z.number().int().positive(),
  merchant: z.object({ name: z.string(), location: z.string().nullable() }),
  drop: z.object({
    label: z.string().nullable(),
    code: z.string().nullable(),
    commune: z.string().nullable(),
  }).strict(), // ⇐ STRICT : refuse lat/lng client (règle 2 du contrat)
}).strict();

const TrackingMapSection = z.object({
  type: z.literal('tracking_map'),
  courier_position: z.object({ lat: z.number(), lng: z.number() }),
  destination_hint: z.object({ commune: z.string().nullable() }).strict(),
}).strict();

const TimelineSection = z.object({
  type: z.literal('timeline'),
  steps: z.array(z.object({
    id: z.string(),
    label: z.string(),
    done: z.boolean(),
    ts: z.string().nullable(),
  })).min(1).max(20),
}).strict();

const ACTION_WHITELIST = ['refresh_tracking', 'contact_support'];

const OrderTrackingSchema = z.object({
  schema_version: z.literal('rx.v1'),
  template: z.literal('order_tracking'),
  layout: z.literal('card'),
  priority: z.literal('high'),
  header_text: z.string().min(1),
  sections: z.array(z.union([TrackingStatusSection, TrackingMapSection, TimelineSection]))
    .min(2).max(3)
    .refine((s) => s.filter((x) => x.type === 'tracking_status').length === 1, 'exactement une section tracking_status')
    .refine((s) => s.filter((x) => x.type === 'timeline').length === 1, 'exactement une section timeline'),
  actions: z.array(z.object({
    action_id: z.enum(ACTION_WHITELIST),
    label: z.string().min(1),
  })).max(2),
  meta: z.object({
    intent: z.literal('order_tracking'),
    decision_log_id: z.string().nullable(),
    gate_status: z.record(z.string(), z.any()).default({}),
    resume_context: z.any().nullable(),
    engine_source: z.literal('resource_dispatch'),
    generated_at: z.string(),
    refresh_hint_s: z.number().int().positive().default(10),
  }),
}).strict();

module.exports = { OrderTrackingSchema, TRACKING_STATES, ACTION_WHITELIST };
